import { ProfileState } from '../objects/profileState';
import { ProfileActionTypes, SET_LOGIN, SET_PERMISSIONS, SET_PREFERENCES, SET_PROFILE } from './actionTypes';

const initialState: ProfileState = {
    id: localStorage.getItem('user_id') !== null ? parseInt(<string>localStorage.getItem('user_id')) : null,
    permissions: null,
    preferences: null,
    profile: null,
    retrieved: false,
    token: localStorage.getItem('token')
};

export default (state = initialState, action: ProfileActionTypes): ProfileState => {
    switch (action.type) {
        case SET_PROFILE: {
            return {...state, retrieved: !!state.permissions && !!state.preferences, profile: action.payload};
        }
        case SET_PERMISSIONS: {
            return {...state, retrieved: !!state.profile && !!state.preferences, permissions: action.payload};
        }
        case SET_PREFERENCES: {
            return {...state, retrieved: !!state.permissions && !!state.profile, preferences: action.payload};
        }
        case SET_LOGIN: {
            const { token, user, permissions } = action.payload;
            return {
                ...state,
                id: user.id,
                permissions: permissions,
                profile: user,
                retrieved: true,
                token: token
            };
        }
        default:
            return state;
    }
};